import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Calendar, Sparkles } from "lucide-react";

const ThisDayInLore = () => {
  const [data, setData] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get(`${API}/lore/today`);
        setData(res.data);
      } catch {
        // Silent fail
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    if (!data?.events?.length || data.events.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % data.events.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [data]);

  if (!data?.events?.length) return null;

  const event = data.events[currentIndex];
  const categoryColors = {
    "sci-fi": "from-blue-500/20 to-cyan-500/10 border-blue-500/20",
    "fantasy": "from-emerald-500/20 to-teal-500/10 border-emerald-500/20",
    "superhero": "from-red-500/20 to-orange-500/10 border-red-500/20",
    "horror": "from-purple-500/20 to-violet-500/10 border-purple-500/20",
  };
  const colorClass = categoryColors[event.category] || categoryColors["sci-fi"];

  return (
    <div
      className={`relative overflow-hidden rounded-xl border bg-gradient-to-r ${colorClass} p-5 transition-all duration-500`}
      data-testid="this-day-in-lore"
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-amber-500/15 flex items-center justify-center">
          <Calendar className="w-5 h-5 text-amber-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[10px] font-mono tracking-widest uppercase text-amber-500">This Day in Lore</span>
            <span className="text-[10px] text-slate-500">{data.date}</span>
          </div>
          <p className="text-sm text-white font-medium mb-1">{event.universe} — {event.year_in_lore}</p>
          <p className="text-sm text-slate-300 leading-relaxed">{event.event}</p>
        </div>
      </div>
      {data.events.length > 1 && (
        <div className="flex gap-1 mt-3 justify-center">
          {data.events.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`w-1.5 h-1.5 rounded-full transition-all ${
                i === currentIndex ? "bg-amber-500 w-4" : "bg-white/20"
              }`}
              data-testid={`lore-dot-${i}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ThisDayInLore;
